export default "__VITE_ASSET__CdE$CRMY__"